import { FC } from "react";
import { TwoPanelTemplate } from "~/OnboardingApp/components";
import { RightPanelSection, Meta, LeftPanelImage } from "./components";

export const SomeLogisticsPage: FC = () => {
  return (
    <>
      <Meta />
      <TwoPanelTemplate
        left={<LeftPanelImage />}
        right={<RightPanelSection />}
      />
    </>
  );
};
